import axios from "../../config/axiosConfig";
import { CREATE_BANK_RECEIPT, GET_BANK_RECEIPTS, BANK_RECEIPT_REQUEST, UPDATE_BANK_RECEIPT, DELETE_BANK_RECEIPT,
  BANK_RECEIPT_REQUEST_FAILURE, BANK_RECEIPT_REQUEST_SUCCESS, GET_BANK_RECEIPTS_PAGE } from "../types";

export const getBankReceiptsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id'
      };
      return axios.get("/bank-receipt/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_RECEIPTS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankReceipts = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/bank-receipt/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_RECEIPTS, payload: response?.data?.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getValidatedIncrementedVchNoBankReceipt = (bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(bookId) {
        params = { ...params, bookId: bookId };
      }
      const response = await axios.get("/bank-receipt/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getBankReceiptByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/bank-receipt/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getBankReceiptById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
    
      return axios.get(`/bank-receipt/get/${id}`).then((response) => {
        dispatch({ type: BANK_RECEIPT_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBankReceipt = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: BANK_RECEIPT_REQUEST });
      return axios.post("/bank-receipt/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_BANK_RECEIPT, payload: response.data });
        } else {
          dispatch({
            type: BANK_RECEIPT_REQUEST_FAILURE,
            error: "Bank Receipt create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateBankReceipt = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
      const { auth } = getState();
      return axios.put("/bank-receipt/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Receipt?.Company_Id || auth.company?.id,
            finyearId: data.Receipt?.Finyear_Id || auth.finyear?.id,
            customerId: data.Receipt?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_BANK_RECEIPT,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: BANK_RECEIPT_REQUEST_FAILURE,
            error: "Bank Receipt update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteBankReceipt = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
      const { auth } = getState();
      return axios.delete(`/bank-receipt/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_BANK_RECEIPT, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { transaction: { bankReceipt: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getBankReceiptsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const sendBankReceiptWhatsappMessage = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      // dispatch({ type: BANK_RECEIPT_REQUEST });
      return axios.post("/bank-receipt/send-whatsapp-msg", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        // if (response.data) {
          // dispatch({ type: CREATE_BANK_RECEIPT, payload: response.data });
        // } else {
          // dispatch({
          //   type: BANK_RECEIPT_REQUEST_FAILURE,
          //   error: "Bank Receipt create failed.",
          // });
        // }
        return response.data;
      }).catch((error) => {
        // console.error(error);
        // dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      // console.error(error);
      // dispatch({ type: BANK_RECEIPT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
export const sendMailBankReceipt = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('bankReceiptId', mailData.bankReceiptId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `bank_receipt_${mailData.bankReceiptId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/bank-receipt/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: BANK_RECEIPT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: BANK_RECEIPT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: BANK_RECEIPT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappBankReceipt = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('bankReceiptId', whatsappData.bankReceiptId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `bank_receipt_${whatsappData.bankReceiptId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/bank-receipt/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: BANK_RECEIPT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: BANK_RECEIPT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: BANK_RECEIPT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};